import {
  SET_JOBS
} from 'app/actions/types';

import {
  getCatalogs as getCatalogsSvc
} from 'app/services/catalogs';

export const getCatalogs = params => async dispatch => {
  let catalogs = await getCatalogsSvc(params);

  if (catalogs) {
    dispatch({
      type: SET_JOBS,
      payload: catalogs.params
    });
  }

  return catalogs;
}

export const setCatalogParams = params => async dispatch => {
  dispatch({
    type: SET_JOBS,
    payload: params
  });
}
